import { useEvents } from "api/events";
import {
  getTransactionAttribute,
  getTransactionParam,
} from "components/Layout/Campaign/Common/campaignHelpers";
import { ConditionReadOnly } from "components/Layout/Campaign/Common/CampaignRules/Rule/Conditions/ConditionReadOnly";
import { CampaignConditionData } from "types/campaigns";
import {
  customEventReferralAchievementConditions,
  transactionReferralAchievementConditions,
} from "../helpers";

interface Props {
  condition: {
    attribute: string;
    data: CampaignConditionData;
    operator: string;
  };
  schema?: string;
}

export const Conditions = ({ condition, schema }: Props) => {
  const { useCustomEventSchemaDetails } = useEvents();
  const { data: selectedSchemaDetails } = useCustomEventSchemaDetails(schema);
  const eventCampaignAttribute = /event.body.(.*)/;

  const getDefaultType = (attribute: string) => {
    if (attribute?.match(eventCampaignAttribute)) {
      return (
        selectedSchemaDetails?.schema?.fields?.find(
          ({ name }: { name: string }) => `event.body.${name}` === attribute,
        )?.type || ""
      );
    } else {
      return (
        [
          ...transactionReferralAchievementConditions,
          ...customEventReferralAchievementConditions,
        ].find((condition) => condition.attribute === attribute)?.type || ""
      );
    }
  };

  return (
    <ConditionReadOnly
      condition={{
        ...condition,
        param: getTransactionParam(condition.attribute),
        attribute:
          condition?.operator === "expression"
            ? "expression"
            : getTransactionAttribute(condition?.attribute!),
        type:
          condition?.operator === "expression"
            ? "expression"
            : getDefaultType(getTransactionAttribute(condition?.attribute!)),
      }}
      data-test-id="achievement-condition"
      isRefferalCampaign={false}
    />
  );
};
